import * as React from "react";
import { useCallback } from "react";
import IndeterminateCheckbox from "./IndeterminateCheckbox";
import { useViewerContext } from "../viewer-context";

export default function ShowAllInhibitorsCheckbox({checkedInhibitors, setCheckedInhibitors, disabled}: {
  checkedInhibitors: Record<string, boolean>,
  setCheckedInhibitors: (value: boolean) => void,
  disabled?: boolean,
}) {

  const {
    selectedInhibitors
  } = useViewerContext();

  const checked = !disabled && selectedInhibitors && selectedInhibitors.every(i => checkedInhibitors[i.id]);
  const indeterminate = !disabled && selectedInhibitors && !checked && selectedInhibitors.some(i => checkedInhibitors[i.id]);

  const handleChange = useCallback(() => {
    setCheckedInhibitors(!checked);
  }, [checked]);

  return (
    <IndeterminateCheckbox
      checked={checked}
      indeterminate={indeterminate}
      disabled={disabled}
      onChange={handleChange}
    />
  )

}
